import { v4 as uuidv4 } from 'uuid';

enum SessionStorageKey {
  FASOO_UI_TOKEN = 'fasoo-ui-token',
  DEVICE_ID = 'device-id',
  LOGOUT_CALLBACK_ENTITIES = 'logout-callback-entities',
  FXM2_IS_MANAGER_DOWNLOAD_REMARK = 'fxm2-is-manager-download-remark',
  FXM2_MOBILE_DOWNLOAD_OPTIONS = 'fxm2_mobile_download_options',
}

interface LogoutCallbackEntity {
  logoutUrl: string;
  token: string;
  jwt?: string;
}

export const getToken = (): string | null => {
  return get(SessionStorageKey.FASOO_UI_TOKEN);
};

export const setToken = (token: string): void => {
  return set(SessionStorageKey.FASOO_UI_TOKEN, token);
};

export const removeToken = (): void => {
  return remove(SessionStorageKey.FASOO_UI_TOKEN);
};

export const getDeviceId = (): string => {
  let deviceId = get(SessionStorageKey.DEVICE_ID);
  if (!deviceId) {
    deviceId = uuidv4();
    setDeviceId(deviceId);
  }
  return deviceId;
};

export const setDeviceId = (deviceId: string): void => {
  return set(SessionStorageKey.DEVICE_ID, deviceId);
};

export const removeDeviceId = (): void => {
  return remove(SessionStorageKey.DEVICE_ID);
};

export const appendLogoutCallbackEntity = (entity: LogoutCallbackEntity): void => {
  const prevEntities = getLogoutCallbackEntities();
  const entities = [...prevEntities, entity];
  set(SessionStorageKey.LOGOUT_CALLBACK_ENTITIES, JSON.stringify(entities));
};

export const removeAndGetLogoutCallbackEntities = (): LogoutCallbackEntity[] => {
  const entities = getLogoutCallbackEntities();
  remove(SessionStorageKey.LOGOUT_CALLBACK_ENTITIES);
  return entities;
};

const getLogoutCallbackEntities = (): LogoutCallbackEntity[] => {
  try {
    const entitiesStr = get(SessionStorageKey.LOGOUT_CALLBACK_ENTITIES);
    if (entitiesStr) {
      const entities = JSON.parse(entitiesStr);
      if (Array.isArray(entities)) {
        return entities;
      } else {
        console.log(
          `Invalid data of key '${SessionStorageKey.LOGOUT_CALLBACK_ENTITIES}' : ${entitiesStr}`
        );
      }
    }
  } catch (e) {
    console.log(e);
  }
  return [];
};

export const setIsManagerDownloadRemark = (value: boolean): void => {
  set(SessionStorageKey.FXM2_IS_MANAGER_DOWNLOAD_REMARK, `${value}`);
};

export const getIsManagerDownloadRemark = (): boolean => {
  const moduleMode = get(SessionStorageKey.FXM2_IS_MANAGER_DOWNLOAD_REMARK);
  return moduleMode === 'true' ? true : false;
};

const DownloadAppTypeList = ['fasooview', 'fasooviewplus', 'secureview'] as const;
type DownloadAppType = typeof DownloadAppTypeList[number];
interface MobileDownloadOptions {
  useDownload: boolean;
  downloadAppType: DownloadAppType;
}
export const getMobileDownloadOptions = (): MobileDownloadOptions => {
  const defaultConfig: MobileDownloadOptions = {
    useDownload: false,
    downloadAppType: 'fasooview',
  };
  const optionsStr = get(SessionStorageKey.FXM2_MOBILE_DOWNLOAD_OPTIONS) || '';
  if (optionsStr.length === 0) {
    return defaultConfig;
  }

  try {
    const settingConfig = JSON.parse(optionsStr) as MobileDownloadOptions;
    const returnConfig = { ...defaultConfig };
    if (settingConfig.useDownload) {
      returnConfig.useDownload = settingConfig.useDownload;
    }
    if (DownloadAppTypeList.includes(settingConfig.downloadAppType)) {
      returnConfig.downloadAppType = settingConfig.downloadAppType;
    }
    return returnConfig;
  } catch (error) {
    return defaultConfig;
  }
};

const get = (key: SessionStorageKey): string | null => {
  return window.sessionStorage.getItem(key);
};

const set = (key: SessionStorageKey, value: string): void => {
  return window.sessionStorage.setItem(key, value);
};

const remove = (key: SessionStorageKey): void => {
  return window.sessionStorage.removeItem(key);
};
